import { nodeApi } from "@/redux/api/nodeApi";

const creditPricingPlan = nodeApi.injectEndpoints({
  endpoints: (builder) => ({
    getAiTokenPricingPlan: builder.query({
      query: (args) => ({
        url: `/ai-token-purchase/plans`,
        params: args,
        method: "GET",
      }),
    }),
    createAiTokenPaymentInstance: builder.mutation({
      query: (payload) => ({
        url: "/ai-token-purchase/init-purchase",
        method: "POST",
        body: payload,
      }),
    }),
    verifyAiTokenPayment: builder.mutation({
      query: (payload) => ({
        url: "/ai-token-purchase/verify-purchase ",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["User", "PurchaseCreditAmount"],
    }),
    initTopupPurchase: builder.mutation({
      query: (body: { userEmail: string; packId?: "topup_10" }) => ({
        url: "/ai-token-purchase/topup/init",
        method: "POST",
        body,
      }),
    }),
    verifyTopupPurchase: builder.mutation({
      query: (body: {
        userEmail: string;
        packId?: "topup_10";
        razorpay_order_id: string;
        razorpay_payment_id: string;
        razorpay_signature: string;
      }) => ({
        url: "/ai-token-purchase/topup/verify",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useCreateAiTokenPaymentInstanceMutation,
  useGetAiTokenPricingPlanQuery,
  useVerifyAiTokenPaymentMutation,
  useInitTopupPurchaseMutation,
  useVerifyTopupPurchaseMutation,
} = creditPricingPlan;
